import { render, staticRenderFns } from "./GitbookHelpLink.vue?vue&type=template&id=490e81b4&scoped=true"
import script from "./GitbookHelpLink.vue?vue&type=script&lang=js"
export * from "./GitbookHelpLink.vue?vue&type=script&lang=js"
import style0 from "./GitbookHelpLink.vue?vue&type=style&index=0&id=490e81b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e81b4",
  null
  
)

export default component.exports